import { ReactNode } from 'react';
import emptyCategory from '../assets/categories/empty-category.svg';

type Props = {
    title: string;
    description?: string;
    action?: ReactNode;
    className?: string;
};

export function EmptyCategory({ title, description, action, className = '' }: Props) {
    return (
        <div className={`flex flex-col items-center gap-8 rounded bg-white py-16 ${className}`}>
            <img src={emptyCategory} alt="" width="200" height="150" />
            {description ? (
                <div className="flex flex-col items-center text-center">
                    <p className="m-0 p-0 text-xl font-heavy text-dark-gray">{title}</p>
                    <p className="text-sm text-gray">{description}</p>
                </div>
            ) : (
                <p className="m-0 p-0 text-center text-xl font-heavy text-dark-gray">{title}</p>
            )}
            {action}
        </div>
    );
}
